import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=2741285c&scoped=true&"
import script from "./OrderInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=2741285c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741285c",
  null
  
)

export default component.exports